import {
    ActionReducer,
    ActionReducerMap,
    MetaReducer
  } from '@ngrx/store';
  import { environment } from '../../environments/environment';
  import { localStorageSync, LocalStorageConfig } from 'ngrx-store-localstorage';
  import { CoreState, SessionState } from './_state.interfaces';
  import { storeFreeze } from 'ngrx-store-freeze';
import { sessionReducer } from './session.reducer';
import { navReducer } from './nav.reducer';
import { sessionInitialState } from './_state.inits';

export const coreReducers: ActionReducerMap<CoreState> = {
  session: sessionReducer,
  nav: navReducer
};

// フィーチャーモジュール読込時のdeserialize起動対策
let prevSessionState: SessionState = null;

// ローカスストレージへの保存設定
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  const config: LocalStorageConfig = {
    // keys: [{cart: ['uuid', 'items']}],
    keys: [
      {
        session: {
          // 保持する項目の設定
          serialize: (data: SessionState) => {
            prevSessionState = data;
            return {
              auth: { token: data.auth.token },
              appId: data.appId,
              admin: data.admin,
              userName: data.userName
            };
          },
          // 保持した内容をステートに復元
          deserialize: (data: SessionState) => {
            if (prevSessionState) {
              return prevSessionState;
            }
            const state: SessionState = JSON.parse(JSON.stringify(sessionInitialState));
            state.auth.token = data.auth ? data.auth.token : null;
            state.appId = data.appId;
            state.admin = data.admin;
            state.userName = data.userName;
            return state;
          }
        }
      }
    ],
    rehydrate: true
  };
  return localStorageSync(config)(reducer);
}

export const metaReducers: MetaReducer<CoreState>[] = !environment.production ?
  [storeFreeze, localStorageSyncReducer] :
  [localStorageSyncReducer];
